var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-end" },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal.addModal",
                  modifiers: { addModal: true },
                },
              ],
              staticClass: "my-1",
              attrs: { variant: "primary" },
            },
            [_vm._v(" Add Bank ")]
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          staticClass: "mb-2 col-12",
          attrs: {
            id: "addModal",
            title: "Add Bank Account",
            centered: "",
            "hide-footer": true,
          },
          model: {
            value: _vm.showAddModal,
            callback: function ($$v) {
              _vm.showAddModal = $$v
            },
            expression: "showAddModal",
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-form",
                {
                  staticClass: "mb-2 col-12",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.AddBank($event)
                    },
                  },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Bank Name",
                                "label-for": "bankNameInput",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "bankNameInput", required: "" },
                                model: {
                                  value: _vm.newBank.bankName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newBank, "bankName", $$v)
                                  },
                                  expression: "newBank.bankName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "8" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Type",
                                "label-for": "typeInput",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "typeInput", required: "" },
                                model: {
                                  value: _vm.newBank.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newBank, "name", $$v)
                                  },
                                  expression: "newBank.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Account Number",
                                "label-for": "accNumInput",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "accNumInput", required: "" },
                                model: {
                                  value: _vm.newBank.accountNumber,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newBank, "accountNumber", $$v)
                                  },
                                  expression: "newBank.accountNumber",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Currency",
                                "label-for": "currencyInput",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "currencyInput", required: "" },
                                model: {
                                  value: _vm.newBank.currency,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newBank, "currency", $$v)
                                  },
                                  expression: "newBank.currency",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "Code", "label-for": "code" } },
                            [
                              _c("b-form-input", {
                                attrs: { id: "code", required: "" },
                                model: {
                                  value: _vm.newBank.code,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newBank, "code", $$v)
                                  },
                                  expression: "newBank.code",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Current Balance",
                                "label-for": "currenctBalance",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "currenctBalance",
                                  type: "number",
                                  step: "0.01",
                                },
                                model: {
                                  value: _vm.newBank.currentBalance,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newBank, "currentBalance", $$v)
                                  },
                                  expression: "newBank.currentBalance",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Description",
                                "label-for": "editDescription",
                              },
                            },
                            [
                              _c("b-form-textarea", {
                                attrs: { id: "editDescription", rows: "3" },
                                model: {
                                  value: _vm.newBank.description,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newBank, "description", $$v)
                                  },
                                  expression: "newBank.description",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "modal-footer justify-content-end" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-2",
                          attrs: {
                            variant: "primary",
                            type: "submit",
                            disabled: _vm.invalid,
                          },
                        },
                        [
                          _vm.loading
                            ? _c("b-spinner", {
                                staticClass: "mx-2",
                                attrs: { small: "" },
                              })
                            : _vm._e(),
                          _vm._v(" Add "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: { id: "addCCModal", title: "Add Credit Card", centered: "" },
          model: {
            value: _vm.showAddCCModal,
            callback: function ($$v) {
              _vm.showAddCCModal = $$v
            },
            expression: "showAddCCModal",
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Bank Name",
                        "label-for": "bankNameInput",
                      },
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          dir: _vm.$store.state.appConfig.isRTL ? "rtl" : "ltr",
                          options: _vm.optionBanks,
                          label: "title",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Account Name",
                        "label-for": "accountNameInput",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { id: "accountNameInput", required: "" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "IBAN Code", "label-for": "ibanInput" } },
                    [
                      _c("b-form-input", {
                        attrs: { id: "ibanInput", required: "" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Last 4 digits of CC Number",
                        "label-for": "cc4Input",
                      },
                    },
                    [
                      _c(
                        "b-input-group",
                        { staticClass: "align-items-center" },
                        [
                          _c("b-input-group-prepend", [
                            _vm._v(" XXXX-XXXX-XXXX- "),
                          ]),
                          _c("b-form-input", {
                            attrs: { id: "cc4Input", required: "" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Account Type",
                        "label-for": "accountTypeInput",
                      },
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          dir: _vm.$store.state.appConfig.isRTL ? "rtl" : "ltr",
                          options: _vm.optionAccType,
                          label: "title",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Description",
                        "label-for": "editDescription",
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: { id: "editDescription" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Currency",
                        "label-for": "currencyInput",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "currencyInput",
                          value: "MUR",
                          required: "",
                          readonly: "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: { id: "viewModal", title: "View Bank Account", centered: "" },
          model: {
            value: _vm.showViewModal,
            callback: function ($$v) {
              _vm.showViewModal = $$v
            },
            expression: "showViewModal",
          },
        },
        [
          _c("p", [
            _c("strong", [_vm._v("Bank Name: ")]),
            _vm._v(_vm._s(_vm.selectedBank.bankName)),
          ]),
          _c("p", [
            _c("strong", [_vm._v("Type: ")]),
            _vm._v(_vm._s(_vm.selectedBank.name)),
          ]),
          _c("p", [
            _c("strong", [_vm._v("Account Number: ")]),
            _vm._v(_vm._s(_vm.selectedBank.accountNumber)),
          ]),
          _c("p", [
            _c("strong", [_vm._v("Currency: ")]),
            _vm._v(_vm._s(_vm.selectedBank.currency)),
          ]),
          _c("p", [
            _c("strong", [_vm._v("Code: ")]),
            _vm._v(_vm._s(_vm.selectedBank.code)),
          ]),
          _c("p", [
            _c("strong", [_vm._v("Balance: ")]),
            _vm._v(_vm._s(_vm.selectedBank.currentBalance)),
          ]),
          _c("p", [
            _c("strong", [_vm._v("Description: ")]),
            _vm._v(_vm._s(_vm.selectedBank.description)),
          ]),
          _c("p", [
            _c("strong", [_vm._v("IsActive: ")]),
            _vm._v(_vm._s(_vm.selectedBank.isActive) + " "),
          ]),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "editModal",
            title: "Edit Bank Account",
            centered: "",
            "hide-footer": true,
          },
          model: {
            value: _vm.showEditModal,
            callback: function ($$v) {
              _vm.showEditModal = $$v
            },
            expression: "showEditModal",
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-form",
                {
                  staticClass: "mb-2 col-12",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.editBank($event)
                    },
                  },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Bank Name",
                                "label-for": "bankNameInput",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: { label: "title" },
                                model: {
                                  value: _vm.selectedBank.bankName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.selectedBank, "bankName", $$v)
                                  },
                                  expression: "selectedBank.bankName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "8" } },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "Type", "label-for": "name" } },
                            [
                              _c("b-form-input", {
                                attrs: { id: "name", required: "" },
                                model: {
                                  value: _vm.selectedBank.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.selectedBank, "name", $$v)
                                  },
                                  expression: "selectedBank.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Account Number",
                                "label-for": "accNumInput",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "accNumInput", required: "" },
                                model: {
                                  value: _vm.selectedBank.accountNumber,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.selectedBank,
                                      "accountNumber",
                                      $$v
                                    )
                                  },
                                  expression: "selectedBank.accountNumber",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Currency",
                                "label-for": "currencyInput",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "currencyInput",
                                  value: "MUR",
                                  required: "",
                                },
                                model: {
                                  value: _vm.selectedBank.currency,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.selectedBank, "currency", $$v)
                                  },
                                  expression: "selectedBank.currency",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "Code", "label-for": "code" } },
                            [
                              _c("b-form-input", {
                                attrs: { id: "code", required: "" },
                                model: {
                                  value: _vm.selectedBank.code,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.selectedBank, "code", $$v)
                                  },
                                  expression: "selectedBank.code",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Current Balance",
                                "label-for": "currencbalanceInput",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "currenctBalance",
                                  type: "number",
                                  step: "0.01",
                                },
                                model: {
                                  value: _vm.selectedBank.currentBalance,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.selectedBank,
                                      "currentBalance",
                                      $$v
                                    )
                                  },
                                  expression: "selectedBank.currentBalance",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Description",
                                "label-for": "editDescription",
                              },
                            },
                            [
                              _c("b-form-textarea", {
                                attrs: { id: "editDescription", rows: "3" },
                                model: {
                                  value: _vm.selectedBank.description,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.selectedBank,
                                      "description",
                                      $$v
                                    )
                                  },
                                  expression: "selectedBank.description",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: {
                          type: "button",
                          block: "",
                          disabled: _vm.invalid,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.editBank()
                          },
                        },
                      },
                      [
                        _vm.loading
                          ? _c("b-spinner", {
                              staticClass: "mx-2",
                              attrs: { small: "" },
                            })
                          : _vm._e(),
                        _vm._v("Update "),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-table", {
        attrs: {
          items: _vm.filteredBanks,
          fields: _vm.fields,
          "current-page": _vm.currentPage,
          "per-page": _vm.perPage,
          "sort-by": _vm.sortBy,
          "sort-desc": _vm.sortDesc,
          responsive: "",
          striped: "",
        },
        on: {
          "update:sortBy": function ($event) {
            _vm.sortBy = $event
          },
          "update:sort-by": function ($event) {
            _vm.sortBy = $event
          },
          "update:sortDesc": function ($event) {
            _vm.sortDesc = $event
          },
          "update:sort-desc": function ($event) {
            _vm.sortDesc = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "head(bankName)",
            fn: function (scope) {
              return [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column" },
                  [
                    _c("span", [_vm._v(_vm._s(scope.label))]),
                    _c("b-form-input", {
                      attrs: { placeholder: "Search Bank Name", size: "sm" },
                      model: {
                        value: _vm.filters.bankName,
                        callback: function ($$v) {
                          _vm.$set(_vm.filters, "bankName", $$v)
                        },
                        expression: "filters.bankName",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "head(name)",
            fn: function (scope) {
              return [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column" },
                  [
                    _c("span", [_vm._v(_vm._s(scope.label))]),
                    _c("b-form-input", {
                      attrs: { placeholder: "Search Name", size: "sm" },
                      model: {
                        value: _vm.filters.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.filters, "name", $$v)
                        },
                        expression: "filters.name",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "head(currency)",
            fn: function (scope) {
              return [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column" },
                  [
                    _c("span", [_vm._v(_vm._s(scope.label))]),
                    _c("b-form-input", {
                      attrs: { placeholder: "Search currency", size: "sm" },
                      model: {
                        value: _vm.filters.currency,
                        callback: function ($$v) {
                          _vm.$set(_vm.filters, "currency", $$v)
                        },
                        expression: "filters.currency",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "head(currentBalance)",
            fn: function (scope) {
              return [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column" },
                  [
                    _c("span", [_vm._v(_vm._s(scope.label))]),
                    _c("b-form-input", {
                      attrs: {
                        placeholder: "Search current Balance",
                        size: "sm",
                      },
                      model: {
                        value: _vm.filters.currentBalance,
                        callback: function ($$v) {
                          _vm.$set(_vm.filters, "currentBalance", $$v)
                        },
                        expression: "filters.currentBalance",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "head(description)",
            fn: function (scope) {
              return [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column" },
                  [
                    _c("span", [_vm._v(_vm._s(scope.label))]),
                    _c("b-form-input", {
                      attrs: { placeholder: "Search description", size: "sm" },
                      model: {
                        value: _vm.filters.description,
                        callback: function ($$v) {
                          _vm.$set(_vm.filters, "description", $$v)
                        },
                        expression: "filters.description",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "head(isActive)",
            fn: function (scope) {
              return [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column" },
                  [
                    _c("span", [_vm._v(_vm._s(scope.label))]),
                    _c("b-form-select", {
                      attrs: {
                        options: [
                          { value: null, text: "All" },
                          { value: true, text: "Active" },
                          { value: false, text: "Inactive" },
                        ],
                        size: "sm",
                      },
                      model: {
                        value: _vm.filters.isActive,
                        callback: function ($$v) {
                          _vm.$set(_vm.filters, "isActive", $$v)
                        },
                        expression: "filters.isActive",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "cell(bankName)",
            fn: function (row) {
              return [_vm._v(" " + _vm._s(row.value) + " ")]
            },
          },
          {
            key: "cell(name)",
            fn: function (row) {
              return [_vm._v(" " + _vm._s(row.value) + " ")]
            },
          },
          {
            key: "cell(currentBalance)",
            fn: function (row) {
              return [_vm._v(" " + _vm._s(row.value) + " ")]
            },
          },
          {
            key: "cell(actions)",
            fn: function (row) {
              return [
                _c(
                  "b-dropdown",
                  {
                    attrs: {
                      variant: "link",
                      "toggle-class": "text-decoration-none",
                      "no-caret": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "button-content",
                          fn: function () {
                            return [
                              _c("feather-icon", {
                                staticClass: "text-body align-middle mr-25",
                                attrs: { icon: "MoreVerticalIcon", size: "16" },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [
                    _c(
                      "b-dropdown-item",
                      {
                        attrs: {
                          to: { name: "income", params: { id: row.item.id } },
                        },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "mr-50",
                          attrs: { icon: "EyeIcon" },
                        }),
                        _c("span", [_vm._v("Income")]),
                      ],
                      1
                    ),
                    _c(
                      "b-dropdown-item",
                      {
                        attrs: {
                          to: { name: "expenses", params: { id: row.item.id } },
                        },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "mr-50",
                          attrs: { icon: "EyeIcon" },
                        }),
                        _c("span", [_vm._v("Expenses")]),
                      ],
                      1
                    ),
                    _c(
                      "b-dropdown-item",
                      {
                        attrs: {
                          to: {
                            name: "reconciliation",
                            params: { id: row.item.id },
                          },
                        },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "mr-50",
                          attrs: { icon: "EyeIcon" },
                        }),
                        _c("span", [_vm._v("Reconciliation")]),
                      ],
                      1
                    ),
                    _c(
                      "b-dropdown-item",
                      {
                        directives: [
                          {
                            name: "b-modal",
                            rawName: "v-b-modal.editModal",
                            modifiers: { editModal: true },
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.openEditModal(row.item)
                          },
                        },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "mr-50",
                          attrs: { icon: "EditIcon" },
                        }),
                        _c("span", [_vm._v("Edit")]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "cell(status)",
            fn: function (row) {
              return [
                _c(
                  "b-badge",
                  {
                    attrs: {
                      variant: _vm.getStatusVariant(row.item.status),
                      pill: "",
                    },
                  },
                  [_vm._v(" " + _vm._s(row.item.status) + " ")]
                ),
              ]
            },
          },
          {
            key: "cell(isActive)",
            fn: function (row) {
              return [
                _c(
                  "b-badge",
                  {
                    attrs: {
                      variant: row.item.isActive ? "success" : "danger",
                      pill: "",
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(row.item.isActive ? "Active" : "Inactive") +
                        " "
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _c(
        "div",
        { staticClass: "d-flex justify-content-center mb-1" },
        [
          _vm.loading
            ? _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning", block: "" },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-pagination", {
            staticClass: "my-0",
            attrs: {
              "total-rows": _vm.totalRows,
              "per-page": _vm.perPage,
              align: "center",
              size: "sm",
            },
            model: {
              value: _vm.currentPage,
              callback: function ($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage",
            },
          }),
          _c("b-form-group", [
            _vm._v(
              " Showing " +
                _vm._s(
                  _vm.totalRows > 0
                    ? _vm.perPage * (_vm.currentPage - 1) + 1
                    : 0
                ) +
                " to " +
                _vm._s(
                  _vm.totalRows > 0
                    ? Math.min(_vm.perPage * _vm.currentPage, _vm.totalRows)
                    : 0
                ) +
                " of " +
                _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                " entries "
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }